import { User, Profile } from '@/models/User';

export class Admin extends User {
  protected $name: string = 'Admin';
  protected $endpoint: string = '/users';

  protected filters: object = {
    role: 'administrator',
  };
}
